import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentMethodCard from './PaymentMethodCard';
import PayoutAccountCard from './PayoutAccountCard';
import Guadagni from './Guadagni';
import Spese from './Spese';
import BottomNav from '../BottomNav';
import theme from '../theme';

function Pagamenti({ session, profile }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('guadagni');

  const tabs = [
    { key: 'guadagni', label: '💰 Guadagni' },
    { key: 'spese', label: '💸 Spese' },
  ];

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>
      <div style={{ background: theme.colors.primary, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button onClick={() => navigate('/profilo')} style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: theme.colors.white, fontSize: theme.font.size.xxl }}>💳 Pagamenti</h2>
      </div>

      <div style={{ padding: theme.spacing.xl, paddingBottom: 80 }}>

        <div style={{ border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.lg, marginBottom: theme.spacing.lg }}>
          <div style={{ fontWeight: 600, fontSize: theme.font.size.lg, marginBottom: 14 }}>💳 Metodo di pagamento</div>
          <PaymentMethodCard session={session} />
        </div>

        <div style={{ border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.lg, marginBottom: theme.spacing.xl }}>
          <div style={{ fontWeight: 600, fontSize: theme.font.size.lg, marginBottom: 14 }}>💼 Ricevi pagamenti</div>
          <PayoutAccountCard session={session} />
        </div>

        <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: theme.spacing.lg }}>
          {tabs.map(tab => (
            <button key={tab.key} onClick={() => setActiveTab(tab.key)} style={{
              flex: 1, padding: '10px 12px', border: 'none', background: 'none',
              borderBottom: activeTab === tab.key ? `2px solid ${theme.colors.primary}` : '2px solid transparent',
              color: activeTab === tab.key ? theme.colors.primary : theme.colors.textMuted,
              cursor: 'pointer', fontSize: theme.font.size.md, fontWeight: activeTab === tab.key ? 600 : 400,
            }}>{tab.label}</button>
          ))}
        </div>

        {activeTab === 'guadagni' && <Guadagni session={session} profile={profile} />}
        {activeTab === 'spese' && <Spese session={session} />}
      </div>

      <BottomNav />
    </div>
  );
}

export default Pagamenti;